var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section",
      staticStyle: { height: "auto", padding: "20px 20px 10px 20px" }
    },
    [
      _c(
        "div",
        { staticClass: "triggers", staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-button",
            {
              attrs: { no: "new", disabled: !_vm.isEdit, type: "primary" },
              on: {
                click: function($event) {
                  return _vm.showEditDialog(true)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "edit", disabled: !_vm.isEdit, type: "primary" },
              on: {
                click: function($event) {
                  return _vm.showEditDialog(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "delete", disabled: !_vm.isEdit, type: "danger" },
              on: { click: _vm.remove }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "grid-wrapper", staticStyle: { "flex-grow": "1" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%" },
            attrs: {
              "config-module": "100805",
              "wrap-text": true,
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.exChangeAgentList
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px", "margin-left": "25px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BranchCMP"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-owned-branch-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.toNumArray(
                            _vm.editDialog.form.multipleBranchId
                          ),
                          no: "multipleBranchId",
                          "select-type":
                            _vm.selectTypeNames.basic_data_Office_All,
                          "static-options": _vm.currentOfficeList,
                          multiple: true
                        },
                        on: {
                          input: function(val) {
                            _vm.editDialog.form.multipleBranchId = _vm.toTxt(
                              val
                            )
                          },
                          change: _vm.multipleBranchIdChange
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.BillExchangeAgent"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "exChangeAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          filterable: "",
                          cache: false,
                          "static-options": _vm.agentList,
                          "default-value":
                            _vm.editDialog.form.exChangeAgent || "",
                          "method-params": { bookingAgent: true, active: true }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.onExChangeAgentChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.isDefault") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "defaultAgent" },
                          model: {
                            value: _vm.editDialog.form.defaultAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "defaultAgent", $$v)
                            },
                            expression: "editDialog.form.defaultAgent"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { no: "yes", label: true } },
                            [_vm._v(_vm._s(_vm.$t("Message.Yes")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { no: "no", label: false } },
                            [_vm._v(_vm._s(_vm.$t("Message.No")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-form-item", {
                    attrs: { label: _vm.$t("SeaExport.AgentInfo") }
                  }),
                  _vm._l(7, function(count) {
                    return _c(
                      "el-form-item",
                      {
                        key: "addressLine" + count,
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("el-input", {
                          ref: "addressLine" + count,
                          refInFor: true,
                          staticStyle: { width: "300px" },
                          attrs: {
                            no: "addressLine" + count,
                            "filter-chars": false
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.editDialog.form,
                                "addressLine" + count,
                                count + 1 > 7
                                  ? null
                                  : "blAddressLine" + (count + 1),
                                _vm.maxChars
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showBlAddressDialog($event)
                            }
                          },
                          model: {
                            value: _vm.editDialog.form["addressLine" + count],
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editDialog.form,
                                "addressLine" + count,
                                $$v
                              )
                            },
                            expression: "editDialog.form['addressLine'+count]"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              disabled: _vm.readonly
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }